var map = {
	"./bbc54yyk/logo_ico.svg": 1870,
	"./chaoxinxing/logo_ico.svg": 1874,
	"./yyk/logo_ico.svg": 1886
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 429;


//////////////////
// WEBPACK FOOTER
// ./static/img ^\.\/.*\/logo_ico\.svg$
// module id = 429
// module chunks = 0